import { __ } from '@/hub-shared/utils/i18n';
import { allowGate, type FeatureGateDecision } from './featureGateDecisions';

export const getFecDsnImportGate = (enabled: boolean | undefined): FeatureGateDecision => {
  if (enabled === true) {
    return allowGate();
  }

  return {
    allowed: false,
    reason: 'feature_disabled',
    message: __('Arrive bientôt'),
    severity: 'info',
  };
};

export const readFecDsnImportEnabledFromBootstrap = (bootstrap: unknown): boolean => {
  if (bootstrap !== null && typeof bootstrap === 'object' && 'isFecDsnImportEnabled' in bootstrap) {
    return (bootstrap as { isFecDsnImportEnabled?: boolean }).isFecDsnImportEnabled === true;
  }

  return false;
};

export const getFecDsnImportGateFromBootstrap = (bootstrap: unknown): FeatureGateDecision => {
  return getFecDsnImportGate(readFecDsnImportEnabledFromBootstrap(bootstrap));
};
